import { useNavigate } from 'react-router';
import { ScreenLogin } from '@/components/screens/login-screen';
import { ClerkLoginPage } from '@/lib/auth';
import { clerkEnabled, useSessionStore } from '@/store/session';
import { useScreenProps } from '@/store/theme';

// Modo dev (sem Clerk): "entrar" define a sessão local e vai p/ o catálogo.
function DevLoginPage() {
  const sp = useScreenProps();
  const navigate = useNavigate();
  const signIn = useSessionStore((s) => s.signIn);
  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenLogin
        {...sp}
        onSignIn={() => {
          signIn();
          navigate('/catalog');
        }}
      />
    </div>
  );
}

export const LoginPage = clerkEnabled ? ClerkLoginPage : DevLoginPage;
